import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field, getFormValues } from "redux-form";
import { SimpleField, WideField } from "../../common/Inputs";
import { PhoneInput } from '../../common/PhoneInput';
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { employees, departments } from '../../../constants/settingTypes';
import { DropdownListField } from '../../common/Inputs';
import { getAwaibleEmployeeRoles, RECEPTION_POINT } from '../../../constants/permissions'; 
import { fetchAddresses as fetchAddressesAction } from '../../../actions/addresses';
import { parsePhoneNumber, required as phoneRequired, validate as validatePhone } from '../../../extensions/phoneHelper';
import { clearUpdateSettings } from "../../../actions/settings";
const validate = (values, props) => {
    const { isReceptionPoint } = props;
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }
    
    required('Name');
    required('Login');
    required('Role');
    required('Phone');
    required('Password');
    if (isReceptionPoint)
        required('ReceptionPoint')
    return errors;
}

let EditModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    _onSubmit(values) {
        values.Phone = parsePhoneNumber(values.Phone);
        const roleId = values.Role == undefined ? null : values.Role.Id == undefined ? values.Role : values.Role.Id;
        const receptionPointId = values.Department == undefined ? null : values.Department.Id == undefined ? values.Department : values.Department.Id;
        const submitData = {
            Login: values.Login,
            Password: values.Password,
            Name: values.Name,
            Role: roleId,
            Location: values.Location,
            IsActive: values.User ? values.User.IsActive : false,
            Phone: values.Phone,
            Id: values.Id,
            ReceptionPointId: receptionPointId
        }
        this.props.onSubmit(submitData);
    }

    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            change,
            isNew,
            departments,
            isReceptionPoint,
            crudError } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;
        const awaibleRoles = getAwaibleEmployeeRoles();
        const loginRegexFilter = /[^a-z1-9]/g;
        const passwordRegexFilter = /[^a-zA-Z1-9]/g;
        const receptionPoints = departments != null ? departments.filter(d => d.Type === 0 && d.IsActive) : [];

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новый сотрудник' : 'Редактирование сотрудника'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal'>
                        <Field name='Name' component={SimpleField} label='ФИО' />
                        <Field name='Login' component={SimpleField} label='Логин' regexFilter={loginRegexFilter} />
                        <Field name='Password' component={SimpleField} label='Пароль' regexFilter={passwordRegexFilter} />
                        <Field name='Role' component={DropdownListField} data={awaibleRoles}
                            valueField='Id' textField='Name' label='Роль' />
                        <Field name='Phone' component={PhoneInput} label='Телефон' />
                        <Field name='Location' component={SimpleField} label='Локация' />
                        {isReceptionPoint && <Field name="Department" component={DropdownListField} data={receptionPoints}
                            valueField="Id" textField="FullName" label="Точка приема" />}
                        <Field name='User.IsActive' component={WideField} label='Действует?' type='checkbox' />

                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {crudError && <p>{crudError}</p>}
                    </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

function mapToProps(state, props) {
    const formValues = getFormValues('employeeEdit')(state);
    const isReceptionPoint = formValues && formValues.Role && (formValues.Role === RECEPTION_POINT || formValues.Role.Id === RECEPTION_POINT);
    return {
        fetching: state.application.get('settings')[employees].updateFetching,
        fetchedAddresses: state.application.get('addresses'),
        departments: state.application.get('settings')['departments'].data,
        formValues,
        isReceptionPoint,
        crudError: state.application.get('settings')[employees].updateError
    }
}

EditModal = reduxForm({
    form: 'employeeEdit',
    validate, 
    getFormValues
})(EditModal);

EditModal = connect(mapToProps, { fetchAddressesAction })(EditModal);

export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/employee/EditModal.jsx